<template>
  <tk-container style="background: #fff;">
    <tk-flex center middle class="bg-white">
      <div class="p-30 bg-white" style="width:794px;height:1123px;">
        <div class="p-10" style="width: 100%; height: 100%;border: 3px solid #E52529;font-size:16px">
          <div style="width: 100%; height: 100%;border: 1.5px solid #E52529;color: #222222;">
            <tk-flex middle center style="padding:50px 0 60px 0;">
              <div style="font-weight: bold;font-size: 40px;color: #000000;line-height: 36px;">成交通知书</div>
            </tk-flex>
            <tk-flex column class="p-x-30">
              <div style="font-size: 18px;line-height: 21px;">{{bidRecord.user.company.name}}:</div>
              <div class="line-clamp-5" style="padding-top:20px;font-size: 18px;line-height: 28px;">
                贵方于<span style="text-decoration:underline">{{setTime(bidRecord.createdAt)}}</span>所参加的<span style="text-decoration:underline">{{bidRecord.announcement.headline}}</span>竞标，经评定，贵方被确定为成交单位。</div>
            </tk-flex>
            <!-- 基本信息 -->
            <div>
              <tk-flex class="p-x-30" style="padding-top:80px">
                <div class="p-r-15" style="width:100px;text-align:right">招标机构:</div>
                <div style="flex-grow:1">{{bidRecord.announcement.user.mechanism}}</div>
              </tk-flex>
              <tk-flex class="p-x-30" style="padding-top:20px">
                <div class="p-r-15" style="width:100px;flex-shrink:0;text-align:right">项目名称:</div>
                <div class="line-clamp">{{bidRecord.announcement.headline}}</div>
              </tk-flex>
              <tk-flex v-if="bidRecord.announcement.tenderMethod === 'directSelection'" class="p-x-30" style="padding-top:20px">
                <div v-if="bidRecord.announcement.directSelectionInfo &&  bidRecord.announcement.directSelectionInfo.mode == 'thousandth'" class="p-r-15" style="width:100px;text-align:right">成交千分比:</div>
                <div v-else class="p-r-15" style="width:100px;text-align:right">成交金额:</div>
                <div v-if="bidRecord.announcement.directSelectionInfo &&  bidRecord.announcement.directSelectionInfo.mode === 'thousandth'">{{bidRecord.money}}‰</div>
                <div v-else>{{bidRecord.money ? `￥${Number(bidRecord.money).toFixed(2)}` : `-`}}</div>
              </tk-flex>
              <tk-flex v-else class="p-x-30" style="padding-top:20px">
                <div v-if="bidRecord.announcement.tenderMethod !== 'percentLowerBid'" class="p-r-15" style="width:100px;text-align:right">成交金额:</div>
                <div v-else class="p-r-15" style="width:100px;text-align:right">成交千分比:</div>
                <div v-if="bidRecord.announcement.tenderMethod !== 'percentLowerBid'">{{bidRecord.money ? `￥${Number(bidRecord.money).toFixed(2)}` : `-`}}</div>
                <div v-else>{{bidRecord.money}}‰</div>
              </tk-flex>
            </div>
            <tk-flex between style="padding: 47px 50px 33px 50px">
              <tk-flex column middle center
                style="width:190px;height:190px;position:relative"
                :style="{
                  height: height
                }"
                >
                <div class="p-b-15" style="width:100%;text-align:center">{{bidRecord.announcement.user.mechanism}}</div>
                <div style="height:21px;width:100%" v-if="bidRecord.announcement.user.mechanism.length <= 6"></div>
                <tk-image
                  class="official-seal"
                  v-if="bidRecord.announcement.user.officialSeal"
                  :src="bidRecord.announcement.user.officialSeal"
                  :width="160"
                  :height="160"
                ></tk-image>
              </tk-flex>
              <tk-flex center middle column style="width:190px;height:190px;position:relative">
                <div class="full-width"
                  style="text-align:center"
                  :class="[company.length > 11 ? '' : 'p-b-15']"
                  >{{company}}</div>
                <div style="text-align:center;width:100%">{{setTime(new Date())}}</div>
                <tk-image
                  class="official-seal"
                  v-if="officialSeal"
                  :src="officialSeal"
                  :width="160"
                  :height="160"
                ></tk-image>
              </tk-flex>
            </tk-flex>
            <tk-flex column center middle>
              <tk-qrcode :value="value" :size="160"></tk-qrcode>
              <div class="p-t-5" style="font-size: 12px;line-height: 16px;color: #666666;">扫码查看成交信息</div>
            </tk-flex>
          </div>
        </div>
      </div>
    </tk-flex>
  </tk-container>
</template>
<script>
export default {
  data () {
    return {
      // 隆尧
      cloudUrl: 'https://cloud.lyxejy.mokekeji.com',
      baseUrl: 'https://lyxejy.xtly0319.com',
      bidRecord: {
        announcement: {
          headline: '',
          user: {
            mechanism: '',
            officialSeal: ''
          }
        },
        user: {
          company: {
            name: ''
          }
        },
        money: 0
      },
      officialSeal: '', // 公章
      value: '123',
      company: ''
    }
  },
  computed: {
    height () {
      let length = this.bidRecord.announcement.user.mechanism.length
      if (length <= 22) return '190px'
      return '235px'
    }
  },
  mounted () {
    this.getInit()
  },
  methods: {
    async getInit () {
      let id = ''
      let index = this.$route.query.params.indexOf(',')
      if (index > -1) {
        let params = this.$route.query.params ? this.$route.query.params.split(',') : []
        id = params[0]
        let region = params[1]
        if (region === 'jlxejy') {
          this.cloudUrl = 'https://cloud.jlxejy.mokekeji.com'
          this.baseUrl = 'https://xtjlxejy.com'
        }
      } else {
        id = this.$route.query.params
      }
      let { data: res } = await this.$tkParse.get(`${this.cloudUrl}/classes/bidRecord/${id}`, {
        params: {
          include: 'announcement,announcement.user,user,user.company'
        }
      })
      this.value = `${this.baseUrl}/bidRecordDetail?params=${id}`
      this.bidRecord = res
      await this.getSetting()
    },
    // 获取setting中数据
    async getSetting () {
      let { data: res } = await this.$tkParse.get(`${this.cloudUrl}/settings/officialSeal`)
      this.officialSeal = res
      let { data: company } = await this.$tkParse.get(`${this.cloudUrl}/settings/company`)
      this.company = company
    },
    setTime (isoString) {
      let date = new Date(isoString)
      return (date.getFullYear() + '年' + (date.getMonth() + 1) + '月' + date.getDate() + '日').replace(/(?=\b\d\b)/g, '0')
    }
  }
}
</script>
<style lang="scss" scoped>
div{
  box-sizing: border-box !important;
}
.official-seal{
  position: absolute;
  top: 0;
  z-index: 0;
}
.line-clamp{
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.line-clamp-5{
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
}
</style>
